import api from '@/api/talentRecommendation'

const state = {

}

const actions = {
  getRecommendationList (context, { jobId, params }) {
    return api.getRecommendationList(jobId, params)
  },
  createRecommendation (context, data) {
    return api.createRecommendation(data)
  },
  getRecommendationCreateTask (taskId) {
    return api.getRecommendationCreateTask(taskId)
  },
  createRecommendMoreTask (context, recommendationId) {
    return api.createRecommendMoreTask(recommendationId)
  },
  createRetryRecommendTask (context, { recommendationId, loadTaskId }) {
    return api.createRetryRecommendTask(recommendationId, loadTaskId)
  },
  getRecommendMoreTask (context, { recommendationId, taskId }) {
    return api.getRecommendMoreTask(recommendationId, taskId)
  },
  getRecommendedTalentList (context, { recommendationId, params }) {
    return api.getRecommendedTalentList(recommendationId, params)
  },
  batchUpdateRecommendedTalent (context, { recommendationId, data }) {
    return api.batchUpdateRecommendedTalent(recommendationId, data)
  },
  updateRecommendedTalentViewed (context, { recommendationId, candidateId }) {
    return api.updateRecommendedTalentViewed(recommendationId, candidateId)
  }
}

const mutations = {

}

const getters = {

}
export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
}
